module.exports = __webpack_public_path__ + "9d756278448508c3c30eca07d46f82cf.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_3-660.webp.png
// module id = 306
// module chunks = 0